import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Tooltip,
} from "@mui/material";
import { RiMenuLine } from "@remixicon/react";
import { useAuth } from "../../contexts/AuthContext";

interface TopNavbarProps {
  onHamburgerClick: () => void;
  isSidebarOpen: boolean;
}

const TopNavbar: React.FC<TopNavbarProps> = ({
  onHamburgerClick,
  isSidebarOpen,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { userProfilePic, logout } = useAuth();
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const controlNavbar = () => {
    if (window.scrollY > 35) {
      setVisible(false);
    } else {
      setVisible(true);
    }
    setLastScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, [lastScrollY]);

  return (
    <AppBar
      position="fixed"
      className={`top-navbar ${isSidebarOpen ? "shrink" : ""}`}
      style={{
        opacity: visible ? 1 : 0,
        transition: "opacity 0.3s",
        visibility: visible ? "visible" : "hidden",
      }}
    >
      <Toolbar>
        {!isSidebarOpen && (
          <Tooltip title="Show menu" arrow>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={onHamburgerClick}
            >
              <RiMenuLine />
            </IconButton>
          </Tooltip>
        )}
        <div className="flex-grow" />
        <IconButton onClick={handleAvatarClick}>
          <Avatar src={userProfilePic} />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={logout}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default TopNavbar;
